import { render, staticRenderFns } from "./tbnnTable.vue?vue&type=template&id=08874155&scoped=true"
import script from "./tbnnTable.vue?vue&type=script&lang=ts"
export * from "./tbnnTable.vue?vue&type=script&lang=ts"
import style0 from "./tbnnTable.vue?vue&type=style&index=0&id=08874155&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08874155",
  null
  
)

export default component.exports